export enum DaylightDateFormat {
  DATE = "MM/DD/YYYY",
  DATE_WITH_WEEKDAY = "ddd, MM/DD/YYYY",
  DATE_WITH_SHORT_YEAR = "MM/DD/YY",
  DATE_WITH_SHORT_YEAR_MILITARY = "MM/DD/YY, HHmm",
  TIME_12 = "hh:mm A",
  TIME_12_LOWER = "hh:mm a",
  WEEKDAY = "dddd",
  SHORT_WEEKDAY = "ddd",
  WEEKDAY_WITH_TIME_WITHOUT_TIMEZONE = "ddd, HHmm",
  WEEKDAY_WITH_TIME_WITHOUT_TIMEZONE_WITH_COLON = "ddd, HH:mm",
  TIME_24_WITH_SECONDS = "HH:mm:ss",
  DATE_TIME_12 = "MM/DD/YYYY hh:mm A",
  DATE_TIME_12_MILITARY = "MM/DD/YYYY HHmm",
  ISO_DATE = "YYYY-MM-DD",
  ISO_DATE_TIME_WITH_TIMEZONE = "YYYY-MM-DDTHH:mm:ssZ",
  ISO_DATE_TIME_WITHOUT_TIMEZONE = "YYYY-MM-DDTHH:mm:ss",
  DATE_WITH_SHORT_DAY_OF_WEEK = "ddd, MM/DD/YY",
  DATE_WITH_SHORT_DAY_OF_WEEK_AND_TIME = "ddd, MM/DD/YY, hh:mm A",
  DATE_WITH_SHORT_DAY_OF_WEEK_AND_MILITARY_TIME = "ddd, MM/DD/YY, HHmm",
  DATE_WITH_SHORT_DAY_OF_WEEK_AND_MILITARY_TIME_WITH_COLON = "ddd MM/DD/YY, HH:mm",
  MILITARY_TIME = "HHmm",
  LOCAL_TIME = "hh:mm:ss",
  DATE_TIME_LONG = "MMMM D, hh:mma",
  SHORT_DATE_WITH_WEEKDAY = "ddd, MMM D",
  SHORT_DATE_WITH_WEEKDAY_PADDED = "ddd, MMM DD",
  SHORT_MONTH_DAY_YEAR_HOUR = "MMM DD, YYYY hh:mm A",
  SHORT_MONTH_DAY_YEAR = "MMM DD, YYYY",
  SHORT_MONTH_DAY = "MMM DD",
  MONTH_YEAR = "MMMM YYYY",
  MONTH_LONG = "MMMM",
  DAY_MONTH_YEAR_SLASH = "DD/MM/YYYY",
  WEEKDAY_FULL_DATE = "dddd, MMMM D, YYYY",
  TIME_WITH_UNITS = "H[h] m[min]",
}
